import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-consults',
  templateUrl: './consults.component.html',
  styleUrls: ['./consults.component.scss']
})
export class ConsultsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
